import Immutable from 'immutable'
import cc from 'classcat'

import FormGroup from '../../formComponents/FormGroup'
import FormValue from '../../formComponents/FormValue'

type AddCategoryPanelProps = {
  categories: ImmutableList
} & TranslateProps

export default function AddCategoryPanel({ categories, t }: Readonly<AddCategoryPanelProps>) {
  const defaultCategory = Immutable.List([
    Immutable.Map({
      id: '',
      name: t('assignCategorySection.defaultSelectValueName'),
    }),
  ])

  const categoryOptions = defaultCategory
    .concat(categories.sortBy((category) => category?.get('name').toLowerCase()))
    .map((category) => {
      if (!category) return null

      return (
        <option key={category.get('id')} value={category.get('id')}>
          {category.get('type') ? `${category.get('name')} (${category.get('type')})` : `${category.get('name')}`}
        </option>
      )
    })

  const defaultUnselectedValue = defaultCategory.getIn(['0', 'id'])

  return (
    <FormGroup name="selectedCollectionInfo" tagName="label" label={t('assignCategorySection.label')}>
      <FormValue name="selectedCollectionInfo">
        {(selectedCollectionInfo, setSelectedCollectionInfo) => (
          <>
            <FormGroup
              className={cc(['ep-form-row-small-margin', { disabled: !categories || categories.isEmpty() }])}
              name="createWithCollection"
              tagName="label"
              labelAfterComponent={true}
              label={t('assignCategorySection.displayProductsCheckbox')}
            >
              <input
                className="ep-form-row-checkbox"
                type="checkbox"
                name="createWithCollection"
                onChange={(e) =>
                  setSelectedCollectionInfo(
                    Immutable.Map({
                      isActive: e.target.checked,
                      collectionId: defaultUnselectedValue,
                    }),
                  )
                }
                disabled={!categories || categories.isEmpty()}
              />
            </FormGroup>
            {selectedCollectionInfo.get('isActive') && (
              <div className="ep-form-row">
                <select
                  className="ep-form-select"
                  defaultValue={defaultUnselectedValue}
                  onChange={(e) =>
                    setSelectedCollectionInfo(
                      Immutable.Map({
                        isActive: selectedCollectionInfo.get('isActive'),
                        collectionId: e.target.value,
                      }),
                    )
                  }
                >
                  {/* to remove 'Select collection' from options - since the first element is dummy element by default */}
                  {(selectedCollectionInfo.get('collectionId') === ''
                    ? categoryOptions
                    : categoryOptions.slice(1)
                  ).toArray()}
                </select>
              </div>
            )}
          </>
        )}
      </FormValue>
    </FormGroup>
  )
}
